import { Table, Typography } from 'antd'
import { Edit2 } from 'iconsax-react'
import { useNavigate } from 'react-router-dom'
import { ColumnsType } from 'antd/es/table'
import { AdminsEcommerceInventoryStockLocationListResponseItem } from 'generated/api'
import { mapStatusStockLocation } from 'helpers/wording'
import ButtonLink from 'components/button/Button'

export interface PropsMerchantTable {
  data: AdminsEcommerceInventoryStockLocationListResponseItem[]
  loading: boolean
  onClickDetail: (id: string) => void
}

function StockLocationTable(props: PropsMerchantTable) {
  const navigate = useNavigate()

  const columnsOrder: ColumnsType<AdminsEcommerceInventoryStockLocationListResponseItem> = [
    {
      title: (
        <div data-testid="btn_sort_name" className="flex">
          <Typography.Text className="font-semibold text-gray-800">No.</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'nomor',
      key: 'nomor',
      render: (_text, _row, index) => (
        <div data-testid="link_column_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{index + 1}.</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="btn_sort_name" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Lokasi</Typography.Text>
        </div>
      ),
      width: '20%',
      dataIndex: 'name',
      key: 'name',
      render: stockLocationName => (
        <div data-testid="link_column_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {stockLocationName}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="btn_sort_name" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Vendor</Typography.Text>
        </div>
      ),
      width: '20%',
      dataIndex: 'vendorName',
      key: 'vendorName',
      render: vendorName => (
        <div data-testid="link_column_vendorName" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {vendorName || '-'}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div data-testid="btn_sort_invoice" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Kota</Typography.Text>
        </div>
      ),
      width: '10%',
      dataIndex: 'city',
      key: 'city',
      render: stockLocationCity => (
        <div data-testid="link_column_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {stockLocationCity}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div
          data-testid="btn_sort_totalPrice"
          className="flex items-center justify-between hover:cursor-pointer"
        >
          <Typography.Text className="font-semibold text-gray-800">Jam Buka</Typography.Text>
        </div>
      ),
      width: '10%',
      dataIndex: 'openHour',
      key: 'openHour',
      render: (openHour, row) => (
        <Typography.Text className="font-medium">
          {openHour + ' - ' + row.closeHour}
        </Typography.Text>
      ),
    },
    {
      title: (
        <div data-testid="btn_sort_stock_and_price" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Stok & Harga</Typography.Text>
        </div>
      ),
      width: '20%',
      dataIndex: 'id',
      key: 'id',
      render: (id, row) => {
        return (
          <div className="flex flex-col">
            <ButtonLink
              data-testid="button_manage_stock"
              variant="outline-primary"
              block={true}
              label="KELOLA"
              className="border font-bold"
              onClick={() =>
                navigate(`/inventory/stock-location/stock/${id}`, {
                  state: { storeName: row.name },
                })
              }
            />
          </div>
        )
      },
    },
    {
      title: (
        <div data-testid="btn_sort_status" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Status</Typography.Text>
        </div>
      ),
      width: '10%',
      dataIndex: 'status',
      key: 'status',
      render: stockLocationStatus => {
        return (
          <Typography.Text className="font-medium">
            {mapStatusStockLocation(stockLocationStatus)}
          </Typography.Text>
        )
      },
    },
    {
      title: (
        <div data-testid="head_col_action" className="flex">
          <Typography.Text className="font-semibold text-gray-800">Aksi</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'action',
      key: 'action',
      render: (_text, row) => {
        return (
          <Edit2
            data-testid="btn_action_edit"
            size="16"
            color="#3C5337"
            className="hover:cursor-pointer"
            onClick={() => props.onClickDetail(row.id)}
          />
        )
      },
    },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.loading}
      data-testid="table_stock_location"
      className="table-primary table-primary--admin sticky-table-header"
      columns={columnsOrder}
      dataSource={props.data}
      pagination={false}
    />
  )
}

export default StockLocationTable
